export default "__VITE_ASSET__74e21f93__"